export default __webpack_public_path__ + "static/simple-scatter-fe0ac3451eedcf45ce61a2eb72504240.png";